<template>
  <div class="QR-page">
    <img class="ys-logo" src="/static/images/landing-page/ys_logo_primary-black.svg" />
    <div class="title" v-if="this.default && !this.ios && !this.android">Download the app <br> to create your account</div>
    <div class="options" v-if="this.default && !this.ios && !this.android">
      <div class="app-icon-container">
        <img
          src="/static/images/landing-page/apple-store.svg"
          aspect-ratio="1"
          height="54"
          width="187"
          @click="showQR('ios')"
          class="cursor-pointer"
        />
      </div>
      <div class="app-icon-container">
        <img
          src="/static/images/landing-page/google-play.svg"
          aspect-ratio="1"
          height="54"
          width="187"
          @click="showQR('android')"
          class="cursor-pointer"
        />
      </div>
    </div>

    <div class="options" v-if="this.ios || this.android">
      <div class="title">
        {{
          this.ios
            ? "Download iOS app"
            : "Download Android app"
        }}
      </div>
      <div class="qr-code__content--img" style="margin-top: 20%">
        <img
          v-if="this.ios"
          :src="require('@/assets/qr/qrcode_ios.png')"
          width="307"
        />

        <img
          v-if="this.android"
          :src="require('@/assets/qr/qrcode_android.png')"
          width="307"
        />
      </div>
    </div>

    <center v-if="this.ios || this.android" @click="reset"> Go back </center>
  </div>
</template>

<script>
import { reset } from 'numeral';

export default {
  data() {
    return {
      default: true,
      ios: false,
      android: false
    }
  },
  methods: {
    showQR(input) {
      input == "ios" ? this.ios = true : this.android = true
    },
    reset() {
      this.ios = false;
      this.android = false;
    }
  },

}
</script>

<style>
.QR-page {
  background: #000;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 15%;
  gap: 40px;
  min-height: 100vh;
}

.QR-page .title{
  color: #FFF;
  text-align: center;
  font-family: Outfit;
  font-size: 24px !important;
  font-style: normal;
  font-weight: 600;
  line-height: 30.4px !important;
}

.QR-page .options {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.QR-page .options img {
  width: 231px;
}

.QR-page .ys-logo {
  height: 30px;
  margin-bottom: 30%;
}

.QR-page center {
  position: absolute;
  bottom: 0;
  color: #a6a6a6;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// index.vue?6cc32509